import { useEffect } from 'react';
import { GridApi } from 'ag-grid-community';
import { UseControlledAGGridProps } from '../types';

export const useColumnOrder = <
  RowData,
  FullWidthRowData = never,
  RowId extends string = string,
>(
  props: UseControlledAGGridProps<RowData, FullWidthRowData, RowId>,
  api: GridApi | null
) => {
  const columnOrder = props.columnIds;
  const columnOrderEnabled = columnOrder !== undefined;

  useEffect(() => {
    if (!api || !columnOrderEnabled || !columnOrder) {
      return;
    }

    // Convert column IDs to strings for comparison
    const orderMap = new Map(
      columnOrder.map((id, index) => [String(id), index])
    );

    // Get all columns and sort them according to the provided order
    const allColumns = api.getAllGridColumns();
    const columnState = allColumns
      .map(col => ({
        colId: col.getColId(),
        order: orderMap.get(col.getColId()) ?? allColumns.length,
      }))
      .sort((a, b) => a.order - b.order)
      .map(col => ({
        colId: col.colId,
      }));

    api.applyColumnState({ state: columnState, applyOrder: true });
  }, [api, columnOrderEnabled, columnOrder]);

  return {
    columnOrder: columnOrderEnabled ? columnOrder : null,
  };
};
